import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isFamilyRequestDone
    ? _c("ListSkeleton", {
        class: _vm.isMobile ? "px-2" : "px-6",
        attrs: { "data-qa": "appointment_patient_list_skeleton" },
      })
    : _c(
        VList,
        { attrs: { "data-qa": "appointment_family_profiles" } },
        _vm._l(
          _vm.patientListData,
          function ({ patient, errorDescription, patientItemData }, index) {
            return _c(
              VListItem,
              {
                key: `item-${index}`,
                class: { "px-6": !_vm.isMobile },
                attrs: {
                  "data-qa": "appointment_family_profiles_patient",
                  disabled: !!errorDescription,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClickPatient(patient)
                  },
                },
              },
              [
                _c(
                  VListItemContent,
                  [
                    _c(
                      VListItemTitle,
                      { staticClass: "d-flex align-end" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-body-1",
                            class: errorDescription
                              ? "icon-secondary--text"
                              : "text--text",
                            attrs: {
                              "data-qa":
                                "appointment_family_profiles_patient_fio",
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(patientItemData.fio) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        patientItemData.isEmptyMain
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-body-2 text-secondary--text ml-2",
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$i18next.t(
                                        "Основной профиль",
                                        _vm.options
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    patientItemData.age || errorDescription
                      ? _c(
                          VListItemSubtitle,
                          { staticClass: "text-body-2 mt-1" },
                          [
                            patientItemData.age
                              ? _c(
                                  "div",
                                  {
                                    class: errorDescription
                                      ? "icon-secondary--text"
                                      : "text-secondary--text",
                                    attrs: {
                                      "data-qa":
                                        "appointment_family_profiles_patient_age",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(patientItemData.age) +
                                        "\n        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            errorDescription
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-error--text",
                                    attrs: {
                                      "data-qa":
                                        "appointment_family_profiles_patient_error_description",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$i18next.t(
                                            errorDescription,
                                            _vm.options
                                          )
                                        ) +
                                        "\n        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  VListItemIcon,
                  { staticClass: "align-self-center my-auto" },
                  [
                    _c(
                      VIcon,
                      {
                        class: errorDescription
                          ? "disabled--text"
                          : "text-secondary--text",
                      },
                      [_vm._v("\n        ui-icon-arrow-right\n      ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }
        ),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }